export const GET_ALERTS = "ALERT@GET_ALERTS";
export const GET_ALERTS_INIT = "ALERT@GET_ALERTS_INIT";
export const GET_ALERTS_SUCCESS = "ALERT@GET_ALERTS_SUCCESS";
export const GET_ALERTS_FAILED = "ALERT@GET_ALERTS_FAILED";

export const Add_SINGLE_ALERT = "ALERT@Add_SINGLE_ALERT";

export const GET_UNSEEN_MESSAGES = "HEDGEFUND@GET_UNSEEN_MESSAGES";
export const GET_UNSEEN_MESSAGES_INIT = "HEDGEFUND@GET_UNSEEN_MESSAGES_INIT";
export const GET_UNSEEN_MESSAGES_SUCCESS = "HEDGEFUND@GET_UNSEEN_MESSAGES_SUCCESS";
export const GET_UNSEEN_MESSAGES_FAILED = "HEDGEFUND@GET_UNSEEN_MESSAGES_FAILED";

export const ADD_SINGLE_MESSAGES= "Chat@ADD_SINGLE_MESSAGES";

export const ADD_TOTAL_COUNT= "Chat@ADD_TOTAL_COUNT";

export const ADD_MESSAGE_ALERT= "Chat@ADD_MESSAGE_ALERT";
